import {CHANGE_ROW_COUNT} from "../actions/RowCount";
import Storage from "../helpers/Storage";

const initialState = {
  rowCount: Storage.getPageSize()
};

const RowCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_ROW_COUNT:
        return {
          rowCount: action.payload.rowCount
        };
    default:
        return state;
  }
}

export default RowCountReducer;
